export const excludeNullishFromArray = <NonNullishArrayEl>(
  arr: (NonNullishArrayEl | null | undefined)[],
) => arr.filter((val): val is NonNullishArrayEl => !!val);
